// extracted by mini-css-extract-plugin
export var discard = "_4r-3";
export var muiTooltipTooltip = "_4r-5";
export var notificationBar = "_4r-2";
export var saveButtonHoverSlotWrapper = "_4r-4";
export var show = "_4r-1";
export var spacer = "_4r-0";